// extracted by mini-css-extract-plugin
module.exports = {"balances":"Balances_balances__l5u4t","backgroundTransparent":"Balances_backgroundTransparent__29fO2","hide":"Balances_hide__2a1yH","cardsPath":"Balances_cardsPath__EHwVe"};